<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Membership Rate Comparison</h1>

        <aha-component title="">
            <!-- Dev note: The following line is what you 
                    need for implimentation.
                    
                    Note the 'tables' prop.  This is where the 
                    data is read into the actual component.
                    
                    This component can support 1 or many sets of
                    data, although it's really meant for 2.
                    -->
            <daily-rate-comparison :tables="demoData" />
        </aha-component>

    </div>
</template>

<script>
    import Cookies from 'js-cookie';

    export default {
        data() {
            return {
                // Dev Note:
                //      Each "table" needs 1 set of data.  This example
                //      shows two "tables", each with their own set.
                //      This has been built to take as many tables as
                //      the user wants to throw at it, although most use
                //      cases is 2.
                demoData: [
                    // Demo Data Set 1
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Wednesday & Thursday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$275'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$375'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$475'
                            }
                        ]
                    },
                    // Demo Data Set 2
                    {
                        active: false, // this needs to be false by default
                        tableName: {
                            preTitle: 'MEMBERS',
                            title: '1-Day Member',
                            day: 'Friday'
                        },
                        rates: [
                            {
                                title: 'Early Rate',
                                date: 'Oct. 9 - Dec. 31',
                                rate: '$200'
                            },
                            {
                                title: 'Advanced Rate',
                                date: 'Jan. 1 - Jan. 28',
                                rate: '$300'
                            },
                            {
                                title: 'Standard Rate',
                                date: 'Jan. 29 - Feb. 19',
                                rate: '$400'
                           }
                        ]
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// demo/pages/components/phd-daily-rate-comparison.vue